import React from 'react';
import "../css/Tabla.css"

const MatchesList = ({ matches, onBuyerClick }) => {
  return (
    <div className="matches-list">
      <h3>Resultados de la búsqueda</h3>
      <ul>
        {matches.map((buyer) => (
          <li key={buyer.comprador.id} onClick={() => onBuyerClick(buyer.comprador)}>
            {buyer.comprador.nombre} - {buyer.coincidencias.length} coincidencias
          </li>
        ))}
      </ul>
    </div>
  );
};

export default MatchesList;
